<template>
    <div class="">
        <div class="example-problem" v-for='(item,index,key) in problem_list' :key="index">
            <div class="example-problem-main">
                <h2>{{item.example_problems}}</h2>
                <p>
                    {{item.way}}
                </p>
                <a class="remain">
                    remain to be solved
                    <img class="remain-icon" src="../../../assets/fold.png" width="10">
                </a>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                problem_list: [
                    {
                        example_problems: 'Example problems',
                        way: 'this is a waythis is a waythis is a waythis is a waythis is' +
                        ' a waythis is a waythis is a waythis is a waythis is a waythis is a way'
                    },
                    {
                        example_problems: 'Example problems',
                        way: 'sdjsdahsdgthis is a waythis is a waythis is a waythis is a waythis ' +
                        'is a waythis is a waythis is a waythis is a waythis is a waythis is a way'
                    },
                    {
                        example_problems: 'Example problems',
                        way: 'sdjsdahsdgthis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a way' +
                        'this is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a way'
                    },
                    {
                        example_problems: 'Example problems',
                        way: 'sdjsdahsdgthis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a way' +
                        'this is a waythis is a waythis is a waythis is a waythis is a waythis is a waythis is a way'
                    }
                ]
            }
        },
        props: {
            services: Array
        }
    }
</script>

<style>
    .example-problem {
        width: 90%;
        margin: 0 auto;
        border-bottom: 2px solid #D3DCE6;
    }

    .example-problem-main {
        width: 95%;
        margin: 20px auto;
    }

    .remain {
        font-size: 16px;
        position: relative;
    }

    .remain-icon {
        position: absolute;
        right: -16px;
        top: -1px;
    }

    .example-problem-main h2 {
        font-size: 24px;
    }

    .example-problem-main p {
        font-size: 16px;
        color: #5E6D82;
        margin: 10px 0 5px 0;
    }

</style>



// WEBPACK FOOTER //
// services_mogo.vue?40ffeb2b